import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation RemoveAssetFromCase($companyId: ID!, $attributes: AssetAssetCaseAttributes!, $id: ID!) {
    removeAssetFromCase(companyId: $companyId, attributes: $attributes, id: $id) {
      assetCase {
        id
        assets { 
          id
        }
      }
      errors {
        path
        message
      }
    }
  }
`
